export interface FIXTaggedField {
  readonly label: string;
  readonly value: string | number | ReadonlyArray<readonly FIXTaggedField[]>;
  readonly type: 'number' | 'string' | 'date' | 'array' | 'unknown';
  readonly tag: number;
}

export interface TextField extends FIXTaggedField {
  readonly value: string;
}

export interface NumberField extends FIXTaggedField {
  readonly value: number;
}

export interface TableField extends FIXTaggedField {
  readonly value: ReadonlyArray<readonly FIXTaggedField[]>;
}

export const isTextField = (field: FIXTaggedField): field is TextField => {
  return typeof field.value === 'string';
};

export const isNumberField = (field: FIXTaggedField): field is NumberField => {
  return typeof field.value === 'number';
};

export const isTableField = (field: FIXTaggedField): field is TableField => {
  return typeof field.value !== 'string';
};
